import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import _ from 'lodash';
import {globalfunc} from '../globalfunc.js';
import { Result } from 'element-ui';
export default {
  namespaced: true,
  state: {
    page: 1,
    size_page: 10,
    SortField: "",
    SortOrder: "",
    team_id: '',
    company_id: '',
    selected_nodes: 'initals',
    selected_attribute: 'impact_rating',
    selected_links: 'all_relational_data',
    loadingRelationshipsTabs: true,
    organization1level: {},
    dataAllAttribute: {},
    datalist: [],
    datalistAll: [],
    _datalistAll:[],
    signatures:[
      {
        id: 'brokerage',
        name: 'Brokerage',
        icon: 'sig_brokerage',
        tooltip: 'Brokerage indicates that an individual frequently lies on the shortest path between other individuals in the network. This suggests that the individual plays a significant role as a bridge or broker, connecting disparate groups and potentially controlling the flow of information or resources.',
        color:''
      },{
        id: 'cohesion',
        name: 'Cohesion',
        icon: 'sig_cohesion',
        tooltip: 'Cohesion measures how an individual’s connections are connected, forming tight-knit groups or clusters. It indicates that an individual’s connections are likely connected, forming tight-knit groups or clusters. This suggests strong relationships and high levels of collaboration within the individual’s local network.',
        color:''
      },{
        id: 'connectivity',
        name: 'Connectivity',
        icon: 'sig_connectivity',
        tooltip: 'Connectivity indicates that an individual has high direct connections within the network. This suggests that the individual is well-connected, which can provide them with access to information, resources, and opportunities.',
        color:''
      },{
        id: 'collective',
        name: 'Collective',
        icon: 'sig_collective',
        tooltip: '‌Collective indicates that a person is central and important in the network. These individuals are well-connected, can reach others more quickly, and may have a higher influence on the flow of information in the network.',
        color:''
      },{
        id: 'influence',
        name: 'Influence',
        icon: 'sig_influence',
        tooltip: '‌Influence indicates that an individual is not only well-connected but also connected to other influential individuals. This means that they might have significant influence within the network and can access diverse information through their connections.',
        color:''
      },{
        id: 'reachability',
        name: 'Reachability',
        icon: 'sig_reachability',
        tooltip: 'Reachability indicates that an individual is well-positioned to spread information or influence others efficiently within the network. The individual is, on average, close to all other individuals in the network, which may provide them with better access to information, resources, and opportunities.',
        color:''
      },
      //FIX code before release
      {
        id: 'influenceI',
        name: 'Collective',
        icon: 'sig_collective',
        tooltip: '‌Collective indicates that a person is central and important in the network. These individuals are well-connected, can reach others more quickly, and may have a higher influence on the flow of information in the network.',
        color:''
      },{
        id: 'influenceII',
        name: 'influence',
        icon: 'sig_influence',
        tooltip: '‌Influence indicates that an individual is not only well-connected but also connected to other influential individuals. This means that they might have significant influence within the network and can access diverse information through their connections.',
        color:''
      },
      {
        id: 'ripple',
        name: 'Ripple',
        icon: 'sig_ripple',
        tooltip: 'Ripple indicates the relative influence this person has by taking into account their direct relationships and how members of the network connect to them through these relationships.',
        color:''
      },
      {
        id: 'hub',
        name: 'Hub',
        icon: 'sig_hub',
        tooltip: 'A Hub is an individual who is both well-connected and can reach others in the network quickly. They serve as a central connecting point in the network.',
        criterion:0.90,
        color:'-blue'
      },
      {
        id: 'strategist',
        name: 'Strategist',
        icon: 'sig_strategist',
        tooltip: 'A Strategist is a person who is often on the shortest paths between others and also connected to other influential people. They hold key strategic positions within the network.',
        criterion:0.90,
        color:'-blue'
      },
      {
        id: 'community_leader',
        name: 'Community Leader',
        icon: 'sig_communityleader',
        tooltip: 'A Community Leader is an individual who has strong, cohesive relationships with a large number of people. They are often seen as the focal point or leader within their communities.',
        criterion:0.90,
        color:'-blue'
      },
      {
        id: 'linker',
        name: 'Linker',
        icon: 'sig_link',
        tooltip: 'A Linker is a powerful bridge builder with considerable influence that ripples throughout the network. They serve as vital links between different communities within the network.',
        criterion:0.90,
        color:'-blue'
      },
      //END FIX code before release
    ],
    statusTeam:false
    // iframeLink: '',
  },
  mutations: {
    setIframeLink(state: any, obj: any) {
      state.team_id = obj.team
      state.company_id = obj.company
    },
    setTeamId(state: any, value: any) {
      state.team_id = value.keyword
    },
    setNodes(state: any, value: string) {
      state.selected_nodes = value
    },
    setAttribute(state: any, value: string) {
      state.selected_attribute = value
    },
    setLinks(state: any, value: string) {
      state.selected_links = value
    },
    setLoadingRelationshipsTabs(state: any, value: any) {
      state.loadingRelationshipsTabs = value
    },
    setOrganization1level(state: any, value: any) {
      state.organization1level = value
    },
    setDataAllAttribute(state: any, value: any) {
      state.dataAllAttribute = value
    },
    setDataList(state: any, value: any) {
      state.datalist = value || [];
    },
    setDataListAll(state: any, value: any) {
      state.datalistAll = value || [];
    },
    set_DataListAll(state: any, value: any) {
      state._datalistAll = value || [];
    },
    setSortField(state: any, result: any) {
      state.SortField = result
    },
    setSortOrder(state: any, result: any) {
      state.SortOrder = result
    },
    setPage(state: any, result: any) {
      state.page = result
    },
    setSelectTeam(state: any, result: any){
      state.statusTeam = result
    }
  },
  actions: {
    async getOrganization({ commit,state, rootState }: any) {
      if(Object.keys(state.organization1level).length == 0){
      const organization1level = {}
        await firebase.firestore().collection('organization1level').where("company", "==", rootState.authen.user.company).get()
        .then(async (querySnapshot)=> {
          querySnapshot.forEach((doc)=> {
            const _data = doc.data()
            organization1level[_data.team_id] = new Object()
            _.forEach(_data.parent, function(_,key) {
              organization1level[_data.team_id][key] = true
            });
          });
          await firebase.database().ref().child('team').orderByChild('company').equalTo(`${rootState.authen.user.company}`).once('value', snapshot => {
            snapshot.forEach((doc):any => {
                const team = doc.val()
                team.key = doc.key
                if(organization1level[team.key] == undefined){
                  organization1level[team.key] = new Object()
                  organization1level[team.key][team.key] = true
                }
            });
            commit('setOrganization1level', organization1level)
          });
        });
      }
    },
    async getAttributeData({commit,dispatch,state,rootState}:any, user:any){
      const organization1level = state.organization1level
      let userMaster={}
      if(Object.keys(rootState.main.allUser).length>0){
        userMaster = rootState.main.allUser
      }else{
        userMaster =  await dispatch('main/getuser',true,{root:true})
      }
      const teamMaster = (await firebase.database().ref('team').orderByChild("company").equalTo(user.company).once('value')).val()
      const relMaster = (await firebase.database().ref('rel_maps').orderByChild("comp_id").equalTo(user.company).once('value')).val()
      let dataAllAttribute:any = {}
      /* set edges most valuable of rel_weight in the same node */
      const data_relweight:any=[]
      _.forEach(relMaster, (item,keyId)=> {
        const userEmail = keyId.replace(/\|\|/g, ".");
        if(userMaster[keyId]){
          const edges = item.edges
          _.forEach(edges, (edges_i)=> {
            if(edges_i.node1 == userEmail || edges_i.node2 == userEmail){
              if(data_relweight[edges_i.node1+"_"+edges_i.node2] == undefined && data_relweight[edges_i.node2+"_"+edges_i.node1] == undefined){
                data_relweight[edges_i.node1+"_"+edges_i.node2] = edges_i.rel_weight
              }else{
                if(data_relweight[edges_i.node1+"_"+edges_i.node2] && data_relweight[edges_i.node1+"_"+edges_i.node2] < edges_i.rel_weight){
                  data_relweight[edges_i.node1+"_"+edges_i.node2] = edges_i.rel_weight
                }else if(data_relweight[edges_i.node2+"_"+edges_i.node1] && data_relweight[edges_i.node2+"_"+edges_i.node1] < edges_i.rel_weight){
                  data_relweight[edges_i.node2+"_"+edges_i.node1] = edges_i.rel_weight
                }
              }
            }
          });
        }
      });
      /* End set edges most valuable of rel_weight in the same node */
      _.forEach(relMaster, (item,keyId)=> {
        const userEmail = keyId.replace(/\|\|/g, ".");
        if(userMaster[keyId]){
          const userObj = Object()
          userObj.firstname = item.firstname
          userObj.lastname = item.lastname
          userObj.fullName = item.firstname + " " + item.lastname
          userObj.cuttingName = item.firstname.charAt(0)+item.lastname.charAt(0)
          userObj.email = userEmail
          userObj.emailKey = keyId
          userObj.profileImage = item.pic
          userObj.boss = (userMaster[keyId].boss) ? userMaster[keyId].boss : ''
          userObj.teamId = (userMaster[keyId].team) ? userMaster[keyId].team : ''
          userObj.teamName = (userMaster[keyId].team&&teamMaster[userMaster[keyId].team]) ? teamMaster[userMaster[keyId].team].name : ''
          // userObj.teamName = _.get(userMaster, `teamMaster[${userMaster[keyId].team}].name`, "")
          userObj.inner_count = 0
          userObj.outer_count = 0
          userObj.strong_count = 0
          userObj.total_count = 0
          userObj.innerMembers = []
          userObj.outerMembers = []
          userObj.strongMembers = []
          userObj.totalMembers = []
          userObj.me_ratio = -1
          userObj.signatures_count = 0
          if(state.signatures.length > 0){
            _.forEach(state.signatures, (signature)=> {
              if(item[signature.id] && item[signature.id].criterion && item[signature.id] >= item[signature.id].criterion){
                if(userObj.signatures == undefined){
                  userObj.signatures = []
                }
                userObj.signatures.push(signature)
                userObj.signatures_count += 1
              } 
              else if(item[signature.id] && item[signature.id] >= 0.85){
                if(userObj.signatures == undefined){
                  userObj.signatures = []
                }
                userObj.signatures.push(signature)
                userObj.signatures_count += 1
              }
            });
          }
          const edges = item.edges
          const nodeCheck:any=[]
          _.forEach(edges, (edges_i)=> {
            if(edges_i.node1 == userEmail || edges_i.node2 == userEmail){
              if(nodeCheck[edges_i.node1+"_"+edges_i.node2] == undefined && nodeCheck[edges_i.node2+"_"+edges_i.node1] == undefined){
                nodeCheck[edges_i.node1+"_"+edges_i.node2] = true
                if(edges_i.node1 == userEmail){
                  const keyIdNode2 = edges_i.node2.replace(/\./g, "||")
                  if(userMaster[keyIdNode2]){
                    if(userMaster[keyId].team && userMaster[keyIdNode2] && userMaster[keyIdNode2].team && organization1level[userMaster[keyId].team] && organization1level[userMaster[keyId].team][userMaster[keyIdNode2].team]){
                      userObj.inner_count += 1
                      userObj.innerMembers.push(keyIdNode2)
                    }else{
                      userObj.outer_count += 1
                      userObj.outerMembers.push(keyIdNode2)
                    }
                    if((data_relweight[edges_i.node1+"_"+edges_i.node2] && data_relweight[edges_i.node1+"_"+edges_i.node2] >= 0.66) || (data_relweight[edges_i.node2+"_"+edges_i.node1] && data_relweight[edges_i.node2+"_"+edges_i.node1] >= 0.66)){
                      userObj.strong_count += 1
                      userObj.strongMembers.push(keyIdNode2)
                    }
                    userObj.totalMembers.push(keyIdNode2)
                  }
                }else if(edges_i.node2 == userEmail){
                  const keyIdNode1 = edges_i.node1.replace(/\./g, "||")
                  if(userMaster[keyIdNode1]){
                    if(userMaster[keyId].team && userMaster[keyIdNode1] && userMaster[keyIdNode1].team && organization1level[userMaster[keyId].team] && organization1level[userMaster[keyId].team][userMaster[keyIdNode1].team]){
                      userObj.inner_count += 1
                      userObj.innerMembers.push(keyIdNode1)
                    }else{
                      userObj.outer_count += 1
                      userObj.outerMembers.push(keyIdNode1)
                    }
                    if((data_relweight[edges_i.node1+"_"+edges_i.node2] && data_relweight[edges_i.node1+"_"+edges_i.node2] >= 0.66) || (data_relweight[edges_i.node2+"_"+edges_i.node1] && data_relweight[edges_i.node2+"_"+edges_i.node1] >= 0.66)){
                      userObj.strong_count += 1
                      userObj.strongMembers.push(keyIdNode1)
                    }
                    userObj.totalMembers.push(keyIdNode1)
                  }
                }
              }
            }
          });
          userObj.total_count = userObj.inner_count + userObj.outer_count
          // if(userObj.total_count > 3){
            dataAllAttribute[keyId] = {}
            Object.assign(dataAllAttribute[keyId], userObj);
          // }
        }
      });
      /* Add M/E Ratio to dataAllAttribute */
      _.forEach(dataAllAttribute, (item,keyId)=> {
        if(item.boss){
          const keyIdBoss = item.boss.replace(/\./g, "||")
          if(dataAllAttribute[keyIdBoss] && dataAllAttribute[keyIdBoss].total_count > 0 && dataAllAttribute[keyId].total_count > 0){
            dataAllAttribute[keyId].me_ratio = globalfunc.round(dataAllAttribute[keyIdBoss].total_count / dataAllAttribute[keyId].total_count, 1)
          }
        }
      });
      /* Add arrData to child */
      _.forEach(dataAllAttribute, (item,keyId)=> {
        if(dataAllAttribute[keyId].totalArrData == undefined){
          dataAllAttribute[keyId].totalArrData = []
        }
        if(item.innerMembers.length > 0){
          dataAllAttribute[keyId].innerArrData = []
          _.forEach(item.innerMembers, (itemInnerMember)=> {
            if(dataAllAttribute[itemInnerMember]){
              dataAllAttribute[keyId].innerArrData.push(dataAllAttribute[itemInnerMember])
              dataAllAttribute[keyId].totalArrData.push(dataAllAttribute[itemInnerMember])
            }
          });
          dataAllAttribute[keyId].innerArrData = _.orderBy(dataAllAttribute[keyId].innerArrData, ['total_count','fullName'], ['desc','asc']);
        }
        if(item.outerMembers.length > 0){
          dataAllAttribute[keyId].outerArrData = []
          _.forEach(item.outerMembers, (itemOuterMember)=> {
            if(dataAllAttribute[itemOuterMember]){
              dataAllAttribute[keyId].outerArrData.push(dataAllAttribute[itemOuterMember])
              dataAllAttribute[keyId].totalArrData.push(dataAllAttribute[itemOuterMember])
            }
          });
          dataAllAttribute[keyId].outerArrData = _.orderBy(dataAllAttribute[keyId].outerArrData, ['total_count','fullName'], ['desc','asc']);
        }
        if(item.strongMembers.length > 0){
          dataAllAttribute[keyId].strongArrData = []
          _.forEach(item.strongMembers, (itemStrongMember)=> {
            if(dataAllAttribute[itemStrongMember]){
              dataAllAttribute[keyId].strongArrData.push(dataAllAttribute[itemStrongMember])
            }
          });
          dataAllAttribute[keyId].strongArrData = _.orderBy(dataAllAttribute[keyId].strongArrData, ['total_count','fullName'], ['desc','asc']);
        }
        dataAllAttribute[keyId].totalArrData = _.orderBy(dataAllAttribute[keyId].totalArrData, ['total_count','fullName'], ['desc','asc']);
      });
      dataAllAttribute = _.orderBy(dataAllAttribute, ['total_count','fullName'], ['desc','asc']);
      commit("setDataAllAttribute", dataAllAttribute)
      dispatch("getDataTable","")
    },
    async getDataTable({commit,dispatch,state,rootState}:any, teamId:any){
      commit('setPage', 1)
      const organization1level = state.organization1level
      if(rootState.authen.user.user_type == 'leadership'){
        if(teamId == "" || state.team_id.search(/all teams/i) == 0){
          teamId = rootState.authen.user.team
        }
      }
      let dataTable:any = {}
      if(teamId && state.team_id.search(/all teams/i) < 0){
        if(Object.keys(organization1level[teamId]).length > 0){
          state.statusTeam=true
          _.forEach(organization1level[teamId], (item,keyId)=> {
            let teamData:any = _.filter(state.dataAllAttribute, { teamId: keyId });
            if(teamData.length > 0){
              _.forEach(teamData, (team_i,index)=> {
                if(team_i && team_i.emailKey){
                  dataTable[team_i.emailKey] = {}
                  Object.assign(dataTable[team_i.emailKey], team_i);
                  // //ADD strong data to dataTable
                  // if(team_i.strongArrData && team_i.strongArrData.length > 0){
                  //   _.forEach(team_i.strongArrData, (strong_i,strong_index)=> {
                  //     if(strong_i && strong_i.emailKey){
                  //       dataTable[strong_i.emailKey] = {}
                  //       Object.assign(dataTable[strong_i.emailKey], strong_i);
                  //     }
                  //   });
                  // }
                }
              });
            }
          });
        }
      }else{
        state.statusTeam=false
        dataTable = state.dataAllAttribute
      }
      var result = Object.values(dataTable);
      let field = state.SortField
      let order = state.SortOrder
      
      if (order === "ascending") {
        order = 'asc'
      } else {
        order = 'desc'
      }
      if (field === "") {
        field = "total_count"
      }
      result = _.orderBy(result, [field,'fullName'], [order,'asc']);
      commit('setDataList', result.slice(0, state.size_page));
      commit('setDataListAll', result);
      commit('set_DataListAll', result);
   
    },
    currentChange({ commit, state }: any, page: any) {
      let size = state.size_page
      let start_row = (page - 1) * size
      let end_row = ((page - 1) * size) + size
      let results: Array<any> = [];
      results = state.datalistAll
      let field = state.SortField
      let order = state.SortOrder
      
      if (order === "ascending") {
        order = 'asc'
      } else {
        order = 'desc'
      }
      if (field === "") {
        field = "total_count"
      }
      results = _.orderBy(results, [field,'fullName'], [order,'asc']);
      commit('setPage', page)
      commit('setDataList', results.slice(start_row, end_row))
    },
    sort({ commit, state }: any, value: any) {
      let results: Array<any> = [];
      results = state.datalistAll
      let size = state.size_page
      let page = state.page
      let start_row = (page-1) * size
      let end_row = ((page-1) * size)+size
      let field = value[0]
      let order = value[1]
      
      if (order === "ascending") {
        order = 'asc'
      } else {
        order = 'desc'
      }
      if (field === "") {
        field = "total_count"
      }
      let _users
      _users = _.orderBy(results, [field,'fullName'], [order,'asc']);
      commit('setSortField', field)
      commit('setSortOrder', order)
      commit('setDataList', _users.slice(start_row,end_row))
    },
    filter({ commit, state }: any, value: any) {
      commit('setPage', 1)
      let results: Array<any> = [];
      // const teamId=value.teamId
      // const organization1level = state.organization1level
      // console.log("value",value)
      if(state.statusTeam==true){
        results = state._datalistAll

      }else{
        results = state.dataAllAttribute
      }

      let size = state.size_page
      let page = state.page
      let start_row = (page-1) * size
      let end_row = ((page-1) * size)+size
      let relation:Array<any>=[]
      // console.log("value",value)
      // console.log("results",results)
      if(value.length>0){
         relation=_.filter(results, function (s) {
          return _.some(s.signatures, function (o) {
            return _.includes(value, o.name);
          });
        });

      }else{
        relation=results
      }
    // console.log("relation",relation)
      commit('setDataList', relation.slice(start_row,end_row))
      commit('setDataListAll', relation);
      
    },
  },
  getters: {
    organization1level: (state: any) => {
      return state.organization1level
    },
    loadingRelationshipsTabs: (state: any) => {
      return state.team_id
    },
    selectTeam: (state: any) => {
      return state.team_id
    },
    iframeLink: (state: any) => {
      // console.log("iframeLink()");
      const api = "https://testdrive.happily.ai";
      // const api = window.location.hostname == "localhost" ? "http://localhost:8081" : "https://testdrive.happily.ai";
      const path = "/relationships-network?";
      if (state.company_id) {
        const company = "company=" + state.company_id;
        const team = (state.team_id && state.team_id.search(/all teams/i) < 0) ? "&team=" + state.team_id : '&team';
        const nodes = state.selected_nodes ? "&nodes=" + state.selected_nodes : '';
        const attribute = state.selected_attribute ? "&attribute=" + state.selected_attribute : '';
        const links = state.selected_links ? "&links=" + state.selected_links : '';
        const mode = "&mode=window"
        const URL = api + path + company + team + nodes + attribute + links + "&v=2";
        // console.log("Open link below to see relationships map for fullscreen version!");
        //console.log(URL + mode);
        return URL
      } else {
        return "";
      }
    },
    datalistAll: (state: any) => {
      return state.datalistAll
    },
    datalist: (state: any) => {
      return state.datalist
    },
    page : (state:any) => {
      return state.page
    },
    signatures : (state:any) => {
      return state.signatures
    },
  }
}
